<script setup lang="ts">
  import type { IItemMenuButton } from '../types'

  const props = defineProps<{
    icon?: string
    value?: string
    label?: string
    link?: string
    active?: boolean
    items?: IItemMenuButton[]
    openDashBoard?: boolean
  }>()

  const openItem = ref(false)

  const toggleItem = (e: Event) => {
    if (props.items?.length) {
      e.preventDefault()
      openItem.value = !openItem.value
    }
  }
</script>

<template>
  <div class="flex flex-col gap-2">
    <NuxtLink
      :to="link"
      active-class="bg-blend-normal"
      class="flex flex-col gap-2"
      @click="toggleItem"
    >
      <div class="relative">
        <Button
          :icon="`i-lucide-${icon}`"
          size="md"
          variant="soft"
          color="neutral"
          class="flex w-full !min-w-8 grow cursor-pointer bg-transparent px-1.5"
          :class="{ 'bg-elevated text-primary': active }"
          :label="label"
        />

        <TransitionContainer
          ><UInput
            v-if="value && openDashBoard"
            disabled
            :value="value"
            :ui="{
              base: 'max-h-5 text-center text-[10px] max-w-5 h-5 w-5 p-0 border-none focus:ring-0 bg-transparent',
            }"
            class="pointer-events-none absolute top-1.5 right-1.5 select-none"
        /></TransitionContainer>

        <TransitionContainer
          ><UIcon
            v-if="items?.length && openDashBoard"
            :name="openItem ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
            class="absolute top-1/2 right-2 -translate-y-1/2"
        /></TransitionContainer>
      </div>
    </NuxtLink>

    <div v-if="openItem && items?.length" class="flex flex-row gap-1 pl-4">
      <span class="bg-accented flex !w-0.25 grow"></span>

      <div class="flex w-full flex-col gap-1">
        <div v-for="(item, index) in items" :key="index" class="relative">
          <Button
            :icon="`i-lucide-${item.icon}`"
            size="md"
            variant="soft"
            color="neutral"
            class="flex w-full !min-w-8 grow cursor-pointer bg-transparent px-1.5"
            :label="item.label"
          />

          <UInput
            v-if="item.value"
            disabled
            :value="item.value"
            :ui="{
              base: 'max-h-5 text-center text-[10px] max-w-5 h-5 w-5 p-0 border-none focus:ring-0 bg-transparent',
            }"
            class="pointer-events-none absolute top-1.5 right-1.5 opacity-0 transition-opacity duration-500 select-none"
            :class="{ 'opacity-100': item.value }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
